import { AdsWindow } from '@ads/types/window';

declare const window: AdsWindow;

export default function getAdxAdid() {
  if (!window) {
    return null;
  }

  let adid = decodeURIComponent(window.document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*adxadid\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;

  if (adid) {
    return adid;
  } else {
    adid = window._dlf.uuidv4();

    const cookie = encodeURIComponent(window.adxadid);
    const subdomain = location.hostname.split('.').reverse()[1];
    const domain = location.hostname.split('.').reverse()[0];
    const expires = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365).toUTCString();
    window.document.cookie = 'adxadid=' + cookie + ';domain=.' + subdomain + '.' + domain + ';path=/;expires=' + expires + ';secure;samesite=lax';
  }

  return adid;
}
